import { UiVariable } from 'pages/AutomationEngine/dialogs/VariableWizard/types';

import { ActionStep } from './subsections/actionSectionTypes';
import { modifyRelatedEntitiesRemoveVariable } from './subsections/ModifyRelatedEntities/modifyRelatedEntitiesRemoveVariable';
import { changeFieldValueRemoveVariable } from './subsections/ChangeFieldValue/changeFieldValueRemoveVariable';
import { callLLMRemoveVariable } from './subsections/CallLLM/callLLMRemoveVariable';
import { updateVariableRemoveVariable } from './subsections/UpdateVariable/updateVariableRemoveVariable';
import { codeStepRemoveVariable } from './subsections/CodeStep/codeStepRemoveVariable';

export const checkVariableUsedInActions = (
  steps: ActionStep[],
  variable: UiVariable
) => {
  const variableName = variable.details.variable.name;

  return steps.some((step) => {
    switch (step.type) {
      case 'modify_related_entities':
        return step.details.fieldsToModify.some((fieldToModify) => {
          return (
            fieldToModify.valueType?.value === 'variable' &&
            fieldToModify.variable?.value === variableName
          );
        });

      case 'change_field_value':
        return (
          step.details.changeType?.value === 'variable' &&
          step.details.variable?.value === variableName
        );

      case 'call_llm':
      case 'file_content_extraction': {
        return (
          step.details.destinationField === 'variable' &&
          step.details.destinations[0]?.variable?.label === variableName
        );
      }

      case 'update_variable': {
        const inSources = step.details?.sources.some(
          (source) =>
            source?.sourceType === 'variable' &&
            source?.automationVariable?.name === variableName
        );

        return (
          step.details?.chosenVariable?.label === variableName || inSources
        );
      }

      case 'code_step': {
        return (
          (step.details?.inputs || []).some(
            (input) =>
              input.inputType === 'variable' &&
              input.variable?.name === variableName
          ) ||
          (step.details?.outputs || []).some(
            (output) =>
              output.outputType === 'variable' &&
              output.variable?.name === variableName
          )
        );
      }

      default:
        return false;
    }
  });
};

export const removeDeletedVariableFromActions = (
  steps: ActionStep[],
  variable: UiVariable
) => {
  const variableName = variable.details.variable.name;
  const errorIds: string[] = [];

  console.log('WATCHING', variable, steps);

  if (variable && steps.length) {
    const nextSteps = steps.map((step) => {
      switch (step.type) {
        case 'modify_related_entities': {
          const { nextStep, nextErrorIds } =
            modifyRelatedEntitiesRemoveVariable(step, variableName, errorIds);

          errorIds.push(...nextErrorIds);

          return nextStep;
        }

        case 'change_field_value': {
          const { nextStep, nextErrorIds } = changeFieldValueRemoveVariable(
            step,
            variableName,
            errorIds
          );

          errorIds.push(...nextErrorIds);

          return nextStep;
        }

        case 'call_llm':
        case 'file_content_extraction': {
          const { nextStep, nextErrorIds } = callLLMRemoveVariable(
            step,
            variableName,
            errorIds
          );

          errorIds.push(...nextErrorIds);

          return nextStep;
        }

        case 'update_variable': {
          const { nextStep, nextErrorIds } = updateVariableRemoveVariable(
            step,
            variableName,
            errorIds
          );

          errorIds.push(...nextErrorIds);

          return nextStep;
        }

        case 'code_step': {
          const { nextStep, nextErrorIds } = codeStepRemoveVariable(
            step,
            variableName,
            errorIds
          );

          console.log('AAAAAAAAAAA', nextStep, nextErrorIds);

          errorIds.push(...nextErrorIds);

          return nextStep;
        }

        default:
          return step;
      }
    });

    return { nextSteps, errorIds };
  }

  return { nextSteps: steps, errorIds };
};
